import React from 'react';
import PropTypes from 'prop-types';

import Label from '../Label';
import * as Icons from '../icons/Icons';
import announce from '../../../helpers/announce';

const propTypes = {
    validationClass: PropTypes.string,
    disableDecreaseCount: PropTypes.bool,
    disableIncreaseCount: PropTypes.bool,
    disableTextInput: PropTypes.bool,
    max: PropTypes.number,
    min: PropTypes.number,
    onCountChange: PropTypes.func,
    count: PropTypes.number,
    label: PropTypes.string,
    iconClass: PropTypes.string,
    inputClass: PropTypes.string
}

const defaultProps = {
    count: 0,
    min: 0,
    max: 999,
    iconClass: 'rec-increment-icon',
    inputClass: 'rec-increment-quantity'
}

export default class Counter extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            count: props.count
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleInputBlur = this.handleInputBlur.bind(this);
    }

    componentDidUpdate(prevProps) {
        const { count } = this.props;

        if (typeof count === 'number' && count !== prevProps.count && count !== this.state.count) {
            this.setState({ count });
        }
    }

    handleInputChange(event) {
        event.preventDefault();
        const value = event.target.value;
        const isNumber = /^\d+$/.test(value);

        if (isNumber) {
            this.setState({ count: value });
            this.props.onCountChange(parseInt(value, 10));
        }
        else if (value === '') {
            this.setState({
                count: ''
            });
        }
        else {
            announce('Error: Enter only numbers.');
        }
    }

    handleInputBlur() {
        const { onCountChange, min, max } = this.props;
        const { count } = this.state;

        if (count === '') {
            let defaultCount = 0;

            if (defaultCount < min) defaultCount = min;

            onCountChange(defaultCount);
            this.setState({ count: defaultCount });
        }
        else {
            let newCount = parseInt(count, 10);

            if (typeof newCount === 'number') {
                if (newCount < min) newCount = min;
                if (newCount > max) newCount = max;

                onCountChange(newCount);
            }
        }
    }

    handleDecreaseCountClick = () => {
        const { min, count } = this.props;
        const newCount = count - 1;
        if (newCount >= min && !this.props.disableDecreaseCount) {
            this.props.onCountChange(newCount);
        }
    }

    handleIncreaseCountClick = () => {
        const { max, count } = this.props;
        const newCount = count + 1;
        if (newCount <= max && !this.props.disableIncreaseCount) {
            this.props.onCountChange(newCount)
        }
    }

    render() {
        const {
            validationClass,
            disableDecreaseCount,
            disableIncreaseCount,
            disableTextInput,
            count,
            label,
            min,
            max,
            iconClass,
            inputClass
        } = this.props;

        let disabledDecreaseCountClass = '';
        let disabledIncreaseCountClass = '';
        let decreaseCountOnClick = this.handleDecreaseCountClick;
        let increaseCountOnClick = this.handleIncreaseCountClick;

        if (disableDecreaseCount || count === min) {
            disabledDecreaseCountClass = 'disabled';
            decreaseCountOnClick = null;
        }
        if (disableIncreaseCount || count === max) {
            disabledIncreaseCountClass = 'disabled';
            increaseCountOnClick = null;
        }

        return (
            <div className="rec-increment-wrap">
                <button
                    className={`${iconClass} ${disabledDecreaseCountClass}`}
                    onClick={decreaseCountOnClick}
                    type="button"
                    disabled={count === min || disableDecreaseCount}
                    aria-label={`Decrease ${label} count by one`}>
                    <span>
                        <Icons.IconRemoveCircleOutline
                            alt={`${count} ${label}`} />
                    </span>
                </button>
                <div className={inputClass}>
                    <Label
                        htmlFor={`${label}-input`}
                        isVisible={false}>
                        {`Number of ${label}s`}
                    </Label>
                    <input
                        id={`${label}-input`}
                        type="text"
                        pattern="\d*"
                        className={validationClass}
                        autoComplete="off"
                        maxLength="3"
                        readOnly={disableTextInput}
                        value={this.state.count}
                        onChange={this.handleInputChange}
                        onBlur={this.handleInputBlur} />
                </div>
                <button
                    className={`${iconClass} ${disabledIncreaseCountClass}`}
                    onClick={increaseCountOnClick}
                    disabled={disableIncreaseCount}
                    type="button"
                    aria-label={`Increase ${label} count by one`}>
                    <span>
                        <Icons.IconAddCircleOutline
                            alt={`${count} ${label}`} />
                    </span>
                </button>
            </div>
        );
    }
}

Counter.propTypes = propTypes;
Counter.defaultProps = defaultProps;
